// extracted by mini-css-extract-plugin
export default {"external-link":"CodesandboxLink_external-link__MKKOU","externalLink":"CodesandboxLink_external-link__MKKOU"};